import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import { Button, Col, FormControl, Row, Well, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IBillingPreparationReportResponse } from '@nkr/store/index';
import { ISortBy, IBaseResponse } from '@nkr/models/index';
import {
    GridApi, ColumnApi, GridReadyEvent,
    CsvExportParams, ProcessHeaderForExportParams, ProcessCellForExportParams, NewValueParams
} from 'ag-grid-community';
import UpdateRmcrFeesModal from './update-rmcr-fees-modal';
import UpdateMonthlyFeesModal from './update-monthly-fees-modal';
import { toast } from 'react-toastify';
import Grid from './grid';
import { OrganType } from '@nkr/enums/organ-type';

const getDates = () => {
    let currentDate = moment().startOf('month');
    let list: moment.Moment[] = [];

    for (let i = 0; i <= 36; i++) {
        var newMoment = moment(currentDate.format('YYYY-MM-DD'));
        list.push(newMoment);
        currentDate = currentDate.subtract(1, 'months');
    }

    return list;
};

interface IOwnProps { }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    updateRmcrFeeByCenter: (centerId: number, newNkrFee: number) => Promise<IBaseResponse>,
    getBillingPreparationReport: (startDate: string, updateFee: boolean, organType: OrganType | null) => Promise<IBillingPreparationReportResponse>,
    updateCenterMonthlyFee: (startDate: string) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    startDate: string,
    endDate: string,
    sortBy: ISortBy[],
    availableMonths: moment.Moment[],
    organTypes: OrganType[],
    showModal: boolean,
    rmcrModal: {
        show: boolean,
        currFeeValue: number,
        newFeeValue: number,
        centerAlias: string,
        pendingRowUpdate: any
    },
    gridApi: GridApi,
    gridColumnApi: ColumnApi
}

class BillPreparationReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        startDate: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDate: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        sortBy: [{ property: 'centerAlias', direction: 'asc' }],
        availableMonths: getDates(),
        organTypes: [OrganType.Kidney],
        showModal: false,
        rmcrModal: {
            show: false,
            centerAlias: '',
            currFeeValue: 0,
            newFeeValue: 0,
            pendingRowUpdate: {}
        },
        gridApi: null,
        gridColumnApi: null
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api,
            gridColumnApi: e.columnApi
        });
    }

    componentDidMount = () => {
        this.getData(true);
    }

    getData = (initialLoad: boolean) => {
        let parsed = qs.parse(window.location.search);
        let startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        let endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');

        if (parsed.startDate != null) {
            startDate = parsed.startDate;
        }

        if (parsed.endDate != null) {
            endDate = parsed.endDate;
        }

        let updateFees = false

        if (parsed['updateFees'] != null) {
            if (parsed['updateFees'] == '1') {
                updateFees = true;
            }
        }

        let organType = parsed.organType ? parseInt(parsed.organType) : OrganType.Kidney;

        if (!initialLoad) {
            let { organTypes } = this.state;
            organType = organTypes.length == 2 ? null : organTypes[0];
        }

        this.setState({
            startDate,
            endDate,
            organTypes: [organType]
        }, () => {
            this.props.showLoading('Getting report data, one moment please...').then(() => {
                this.props.getBillingPreparationReport(startDate, updateFees, organType).then(response => {
                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
            });
        });
    }

    handleStartDateChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        var dateValue = e.currentTarget.value;

        let { organTypes } = this.state;
        let organType = organTypes.length == 2 ? null : organTypes[0];

        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getBillingPreparationReport(dateValue, false, organType).then((response: IBillingPreparationReportResponse) => {
                var endDate: string = moment(dateValue).endOf('month').format('YYYY-MM-DD');

                this.setState({
                    startDate: dateValue,
                    endDate: endDate
                });

                this.props.hideLoading();
            }).catch((ex) => {

                alert('An error occured while loading report data');
                this.props.hideLoading();
            });
        });
    }

    handleShowMonthlyFeeModal = () => {
        this.setState({
            showModal: true
        });
    }

    handleLoadUpdatedMonthlyFeeClick = () => {
        let { organTypes } = this.state;
        let organType = organTypes.length == 2 ? null : organTypes[0];

        this.props.showLoading('Loading Updated Monthly Fee ...').then(() => {
            this.props.getBillingPreparationReport(this.state.startDate, false, organType).then((response: IBillingPreparationReportResponse) => {
                this.props.hideLoading();

                this.setState({
                    showModal: false
                });
            }).catch((ex) => {
                alert('An error occured while loading report data');
                this.props.hideLoading();

                this.setState({
                    showModal: false
                })

            });
        });
    }

    handleLoadMonthlyFeeClick = () => {
        let { organTypes } = this.state;
        let organType = organTypes.length == 2 ? null : organTypes[0];

        this.props.showLoading('Updating Monthly ...').then(() => {
            this.props.getBillingPreparationReport(this.state.startDate, true, organType).then((response: IBillingPreparationReportResponse) => {
                this.props.hideLoading();

                this.setState({
                    showModal: false
                });
            }).catch((ex) => {
                alert('An error occured while loading report data');
                this.props.hideLoading();

                this.setState({
                    showModal: false
                })

            });
        });
    }

    handleRmcrRowUpdate = () => {
        var centerId = this.state.rmcrModal.pendingRowUpdate[0].centerId;
        var newNkrFee = this.state.rmcrModal.newFeeValue;

        this.props.showLoading('Updating RMCR Fee, one moment please...').then(() => {
            this.props.updateRmcrFeeByCenter(centerId, newNkrFee)
                .then((response: IBaseResponse) => {
                    if (response.data.success) {
                        let centerAlias = this.state.rmcrModal.pendingRowUpdate[0].centerAlias;
                        toast.success("Rmcr Fee for '" + centerAlias + "' has been updated.");
                    }

                    this.setState({
                        rmcrModal: {
                            show: false,
                            centerAlias: "",
                            currFeeValue: 0,
                            newFeeValue: 0,
                            pendingRowUpdate: {}
                        }
                    });
                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    handleCancelModal = () => {
        this.setState({
            showModal: false
        });
    }

    handleCancelRmcrModal = () => {
        this.state.gridApi.applyTransaction({ update: this.state.rmcrModal.pendingRowUpdate });

        this.setState({
            rmcrModal: {
                show: false,
                centerAlias: "",
                currFeeValue: 0,
                newFeeValue: 0,
                pendingRowUpdate: {}
            }
        });
    }

    handleActRmcrFeeChange = (params: NewValueParams) => {
        let changedRow = [params.data];

        changedRow[0].nkrFee = params.oldValue;

        //check if new value is a number
        if (!isNaN(params.newValue)) {
            this.setState({
                rmcrModal: {
                    show: true,
                    centerAlias: changedRow[0].centerAlias,
                    pendingRowUpdate: changedRow,
                    currFeeValue: params.oldValue,
                    newFeeValue: params.newValue
                }
            });
        } else {
            this.state.gridApi.applyTransaction({ update: changedRow });
            toast.error("RMCR Fee: Value must be a number.");
        }

        return false;
    }

    handleSort = (sort: string) => {
        let m = [
            {
                sort: 'preselectAverage',
                columns: [
                    { colId: 'preselectAverageSort', sort: 'asc' },
                    { colId: 'preselectAverage', sort: 'desc' }
                ]
            },
            {
                sort: 'dataComplianceFailed',
                columns: [
                    { colId: 'dataComplianceFailedSort', sort: 'asc' },
                    { colId: 'dataComplianceFailed', sort: 'desc' }
                ]
            },
            {
                sort: 'rexmLate',
                columns: [
                    { colId: 'rexmLateSort', sort: 'asc' },
                    { colId: 'rexmLate', sort: 'desc' }
                ]
            },
            {
                sort: 'preselectReversals',
                columns: [
                    { colId: 'preselectReversalsSort', sort: 'asc' },
                    { colId: 'preselectReversals', sort: 'desc' }
                ]
            },
            {
                sort: 'surgicalDeclines',
                columns: [
                    { colId: 'surgicalDeclinesSort', sort: 'asc' },
                    { colId: 'surgicalDeclines', sort: 'desc' }
                ]
            },
            {
                sort: 'lateVxm',
                columns: [
                    { colId: 'lateVxmSort', sort: 'asc' },
                    { colId: 'lateVxm', sort: 'desc' }
                ]
            },
            {
                sort: 'netChainsStarted',
                columns: [
                    { colId: 'netChainsStartedSort', sort: 'asc' },
                    { colId: 'netChainsStartedAbsoluteValue', sort: 'desc' },
                    { colId: 'netChainsStarted', sort: 'desc' }
                ]
            },
            {
                sort: 'ncsGap',
                columns: [
                    { colId: 'ncsGapSort', sort: 'asc' },
                    { colId: 'ncsGap', sort: 'desc' }
                ]
            },
            {
                sort: 'billableRccaps',
                columns: [
                    { colId: 'billableRccapsSort', sort: 'asc' },
                    { colId: 'billableRccaps', sort: 'desc' }
                ]
            },
            {
                sort: 'lateSerologies',
                columns: [
                    { colId: 'lateSerologiesSort', sort: 'asc' },
                    { colId: 'lateSerologies', sort: 'desc' }
                ]
            },
            {
                sort: 'expectedMonthlyDbFee',
                columns: [
                    { colId: 'expectedMonthlyDbFeeSort', sort: 'asc' },
                    { colId: 'expectedMonthlyDbFee', sort: 'desc' }
                ]
            },
            {
                sort: 'expectedMonthlyNkrFee',
                columns: [
                    { colId: 'expectedMonthlyNkrFeeSort', sort: 'asc' },
                    { colId: 'expectedMonthlyNkrFee', sort: 'desc' }
                ]
            },
            {
                sort: 'monthlyFee',
                columns: [
                    { colId: 'monthlyFeeSort', sort: 'asc' },
                    { colId: 'monthlyFee', sort: 'desc' }
                ]
            },
            {
                sort: 'nkrFee',
                columns: [
                    { colId: 'nkrFeeSort', sort: 'asc' },
                    { colId: 'nkrFee', sort: 'desc' }
                ]
            },
            {
                sort: 'fClc',
                columns: [
                    { colId: 'fClcSort', sort: 'asc' },
                    { colId: 'fClc', sort: 'desc' }
                ]
            },
            {
                sort: 'vxmAnalysis',
                columns: [
                    { colId: 'vxmAnalysisSort', sort: 'asc' },
                    { colId: 'vxmAnalysis', sort: 'desc' }
                ]
            },
            {
                sort: 'lateKidneyPickup',
                columns: [
                    { colId: 'lateKidneyPickupSort', sort: 'asc' },
                    { colId: 'lateKidneyPickup', sort: 'desc' }
                ]
            },
            {
                sort: 'voucherHoldersCumulative',
                columns: [
                    { colId: 'voucherHoldersCumulative', sort: 'desc' },
                    // { colId: 'vxmAnalysis', sort: 'desc' }
                ]
            },
        ];

        let cs = this.state.gridColumnApi.getColumnState().map(x => {
            x.sort = null;
            return x;
        });

        let s = m.find(x => x.sort == sort);

        if (s != null) {
            for (var i = 0; i < s.columns.length; i++) {
                let column = s.columns[i];

                let sortSpec = cs.find(x => x.colId == column.colId);

                if (sortSpec != null) {
                    sortSpec.sort = column.sort;
                    sortSpec.sortIndex = i;
                }
            }

            this.state.gridColumnApi.applyColumnState({
                state: cs
            });
        }
    }

    changeOrganType = (values: OrganType | OrganType[]) => {
        let safeValues = Array.isArray(values) ? values : [values];

        if (safeValues.length == 0) return;

        this.setState({
            organTypes: safeValues
        }, () => {
            this.getData(false)
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: `billing-prep-report_${this.state.startDate}_${this.state.endDate}.csv`,
            processHeaderCallback: (params: ProcessHeaderForExportParams) => {
                let headerName = params.column.getColDef().headerName;
                return headerName.replace(/\|/gi, ' ');
            },
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (params.node.rowPinned == 'top') {
                    if (params.node.data.isSummary != undefined) {
                        if (colDef.field == 'centerAlias') {
                            return '';
                        }

                        if (colDef.colId == 'executiveSponsor') {
                            return '';
                        }

                        if (colDef.colId == 'liaison') {
                            return 'Summary >>';
                        }
                    }
                } else {
                    if (colDef.colId == 'executiveSponsor') {
                        return params.value != null ? params.value.abbreviation : '';
                    }

                    if (colDef.colId == 'liaison') {
                        return params.value != null ? params.value.abbreviation : '';
                    }

                    if (colDef.colId == 'lateKidneyPickup') {
                        if (params.node.data.onTimeKidneyPickup < 0)
                            return -1;
                        else
                            return 100 - params.node.data.onTimeKidneyPickup;
                    }

                    if (colDef.colId == 'dashBillingActualFee') {
                        return params.node.data.dashBillingActualFee;
                    }

                    if (colDef.colId == 'isLiverPlDash') {
                        return params.value === true ? 'Yes' : 'No';
                    }

                }

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        const filteredRows = this.props.reports.billingPreparationReport;
        const organValue = this.state.organTypes.length == 2 ? -1 : this.state.organTypes[0];

        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <div>
                        <h4 style={{ margin: 0 }}>Billing Preparation Report from {this.state.startDate} to {this.state.endDate}</h4>
                    </div>
                    <div>
                        <Well bsSize='small' style={{ margin: 0 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ paddingRight: 20 }}>
                                    <div className='bg-yellow' style={{ width: "12px", height: "12px", display: "inline-block" }}></div> Non-Compliant RMCR / Billable
                                </div>
                                <div style={{ paddingRight: 20 }}>
                                    <div className='bg-warning' style={{ width: "12px", height: "12px", display: "inline-block" }}></div> Mismatch with Expected Value
                                </div>
                                <div style={{ paddingRight: 20 }}>
                                    <div className='bg-danger' style={{ width: "12px", height: "12px", display: "inline-block" }}></div> Missing Amount
                                </div>
                                <div>
                                    <div className='bg-override' style={{ width: "12px", height: "12px", display: "inline-block" }}></div> Override Warning
                                </div>
                            </div>
                        </Well>
                    </div>
                </div>

                <div className='well well-sm' style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'nowrap' }}>
                    <span style={{ whiteSpace: 'nowrap' }}>Select Billing Month:</span>
                    <FormControl
                        componentClass='select'
                        value={this.state.startDate}
                        onChange={this.handleStartDateChange}
                        style={{ width: 'auto' }}>
                        <option value=''>Select Month</option>
                        {this.state.availableMonths.map((availableMonth, index) =>
                            <option key={'d-' + index} value={moment(availableMonth).format('YYYY-MM-DD')}>{availableMonth.format('MMM YYYY')}</option>
                        )}
                    </FormControl>
                    <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>&nbsp;Organ:</span>
                    <ToggleButtonGroup type='radio' name='organs' value={organValue}>
                        <ToggleButton value={OrganType.Kidney} onChange={() => this.changeOrganType(OrganType.Kidney)}
                            className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Kidney) ? 'btn-primary btn-md' : 'btn-md'}>Kidney</ToggleButton>
                        <ToggleButton value={OrganType.Liver} onChange={() => this.changeOrganType(OrganType.Liver)}
                            className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Liver) ? 'btn-primary btn-md' : 'btn-md'}>Liver</ToggleButton>
                    </ToggleButtonGroup>
                    <div style={{ marginLeft: 'auto' }}>
                        <Button onClick={this.handleExport}>Export CSV</Button>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-xs-12'>
                        <Grid
                            data={filteredRows}
                            organType={organValue}
                            onGridReady={this.onGridReady}
                            onSort={this.handleSort}
                            onActRmcrFeeChange={this.handleActRmcrFeeChange} />
                    </div>
                </div>

                <UpdateMonthlyFeesModal
                    show={this.state.showModal}
                    onUpdate={this.handleLoadMonthlyFeeClick}
                    onCancel={this.handleCancelModal}
                />
                <UpdateRmcrFeesModal
                    centerAlias={this.state.rmcrModal.centerAlias}
                    show={this.state.rmcrModal.show}
                    currFeeValue={this.state.rmcrModal.currFeeValue}
                    newFeeValue={this.state.rmcrModal.newFeeValue}
                    onUpdate={this.handleRmcrRowUpdate}
                    onCancel={this.handleCancelRmcrModal}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBillingPreparationReport: (startDate, updateFees, organType) => {
            return dispatch(ReportActionCreators.getBillingPreparationReport(startDate, updateFees, organType));
        },
        updateCenterMonthlyFee: (startDate) => {
            return dispatch(ReportActionCreators.updateCenterMonthlyFee(startDate))
        },
        updateRmcrFeeByCenter: (centerId, newNkrFee) => {
            return dispatch(ReportActionCreators.updateCenterNkrFee(centerId, newNkrFee))
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(BillPreparationReport);